import { NgModule } from '@angular/core';
import { RemoveNonAlphanumericPipe } from './remove-non-alphanumeric.pipe';


@NgModule({
  declarations: [RemoveNonAlphanumericPipe],
  exports: [RemoveNonAlphanumericPipe],
})
export class RemoveNonAlphanumericModule { }